import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import api from "../../api/client";

export default function CheckoutCancel() {
  const navigate = useNavigate();
  const { lang } = useLanguage();
  const isAr = lang === "ar";

  const startedRef = useRef(false);
  const [message, setMessage] = useState(
    isAr ? "جارٍ إلغاء عملية الدفع..." : "Cancelling payment..."
  );
  const [error, setError] = useState("");

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    const params = new URLSearchParams(window.location.search);
    const orderId = params.get("order_id");
    const sessionId = params.get("session_id");

    if (!orderId && !sessionId) {
      navigate("/cart", { replace: true });
      return;
    }

    let cancelled = false;

    async function cancelOrder() {
      try {
        setError("");
        setMessage(
          isAr ? "جارٍ إلغاء عملية الدفع..." : "Cancelling payment..."
        );

        const query = sessionId
          ? `checkout/cancel?session_id=${encodeURIComponent(sessionId)}`
          : `checkout/cancel?order_id=${encodeURIComponent(orderId)}`;

        await api.apiGet(query);

        if (cancelled) return;

        window.dispatchEvent(new Event("mg:notifications-refresh"));

        setMessage(
          isAr
            ? "تم إلغاء عملية الدفع، جارٍ تحويلك إلى السلة..."
            : "Payment cancelled, redirecting to cart..."
        );

        setTimeout(() => {
          if (!cancelled) {
            navigate("/cart", { replace: true });
          }
        }, 1200);
      } catch (err) {
        if (cancelled) return;

        setError(
          isAr
            ? "تعذر إلغاء العملية، سيتم إعادتك إلى السلة."
            : "Unable to cancel the checkout. Redirecting to cart."
        );

        setTimeout(() => {
          if (!cancelled) {
            navigate("/cart", { replace: true });
          }
        }, 1200);
      }
    }

    cancelOrder();

    return () => {
      cancelled = true;
    };
  }, [navigate, isAr]);

  return (
    <div className="container py-5 text-center" dir={isAr ? "rtl" : "ltr"}>
      <div className="card shadow-sm border-0 mx-auto" style={{ maxWidth: 560 }}>
        <div className="card-body p-4">
          <h3 className="mb-3">
            {isAr ? "إلغاء عملية الدفع" : "Cancelling Payment"}
          </h3>
          <p className="text-muted mb-0">{message}</p>

          {error && (
            <div className="alert alert-warning mt-3 mb-0" role="alert">
              {error}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}